"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STRING_DEFAULT_LIMIT = exports.QUANTITY_DECIMAL_PLACES = exports.PRICE_DECIMAL_PLACES = exports.DEFAULT_QUANTITY = exports.DEFAULT_CHUNK_SIZE = void 0;
/**
 * The default chunk size used for parallelizing array processing.
 */
exports.DEFAULT_CHUNK_SIZE = 200;
/**
 * The default quantity value.
 */
exports.DEFAULT_QUANTITY = 1;
/**
 * The number of decimal places used for prices.
 */
exports.PRICE_DECIMAL_PLACES = 2;
/**
 * The number of decimal places used for quantity values.
 */
exports.QUANTITY_DECIMAL_PLACES = 5;
/**
 * The default limit for strings.
 */
exports.STRING_DEFAULT_LIMIT = 255;
//# sourceMappingURL=consts.js.map